import { render, staticRenderFns } from "./ChinaStockCenter.vue?vue&type=template&id=67c9e171&scoped=true"
import script from "./ChinaStockCenter.vue?vue&type=script&lang=js"
export * from "./ChinaStockCenter.vue?vue&type=script&lang=js"
import style0 from "./ChinaStockCenter.vue?vue&type=style&index=0&id=67c9e171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9e171",
  null
  
)

export default component.exports